import styled from "styled-components";

export const NavContainer = styled.div`

    background-color: rgb(26,26,39);
    background:transparent;
    width: 100%;
    position: fixed;
    border-bottom: 2px solid rgb(35,35,52);

`
export const NavWrapper = styled.div`

    height: 50px;
    padding: 20px;
   
`

export const NavElement = styled.div`


    float: right;
    padding-left: 20px;
    border-left: 2px solid rgb(35,35,52);
    vertical-align: middle;
    line-height: 50px;

`

export const NavItem = styled.div`

    display: inline-block;
    line-height: 25px;
    align-items: center;
    height: 40px;
    margin: 0 5px;
    padding-right: 30px;
    padding-left: 20px;
    
`
export const NavLink = styled.div`

    color: White;
    font-size: 17px;
    text-transform: uppercase;
`

export const NavLogo = styled.label`

    color: White;
    font-size: 35px;
    line-height: 50px;
    font-wight: bold;
    padding: 0 40px;
    border-right: 2px solid rgb(35,35,52);
`
